export default "__VITE_ASSET__C5XH_bkD__"